/* LED's Move 2.0 — sectie-scripts.
   Eén keer laden is genoeg: init-guard, event delegation op document,
   productlogica idempotent (data-lm-ready) en opnieuw na shopify:section:load. */
(function () {
  if (window.__lmInit) return; window.__lmInit = true;

  /* Toast, ook voor andere secties: window.lmToast('Tekst', 2500)
     of document.dispatchEvent(new CustomEvent('lm:toast', { detail: 'Tekst' })) */
  function toast(msg, ms) {
    if (!msg) return;
    var t = document.getElementById('lmToast');
    if (!t) { t = document.createElement('div'); t.id = 'lmToast'; t.className = 'lm-toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('show');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('show'); }, ms || 2000);
  }
  window.lmToast = toast;
  document.addEventListener('lm:toast', function (e) {
    var d = e.detail; if (typeof d === 'string') toast(d); else if (d) toast(d.message || d.msg, d.ms);
  });

  function money(cents) {
    var f = window.lmMoneyFormat || '€{{amount_with_comma_separator}}';
    var n = (cents / 100).toFixed(2);
    var comma = n.replace('.', ',');
    return f.replace('{{amount_with_comma_separator}}', comma).replace('{{amount}}', n).replace('{{amount_no_decimals}}', Math.round(cents / 100)).replace(/\{\{.*?\}\}/g, comma);
  }
  window.lmMoney = money;

  /* Hero: licht aan/uit, gedelegeerd zodat het ook werkt na section reload in de editor */
  document.addEventListener('click', function (e) {
    var tog = e.target.closest('[data-lm-toggle]'); if (!tog) return;
    var hero = tog.closest('[data-lm-hero]'); if (!hero) return;
    e.preventDefault();
    var on = !hero.classList.contains('on');
    hero.classList.toggle('on', on); tog.setAttribute('aria-pressed', on ? 'true' : 'false');
    var state = hero.querySelector('[data-tog-state]'), hint = hero.querySelector('[data-tog-hint]'), vid = hero.querySelector('video');
    if (state) state.textContent = on ? tog.dataset.on : tog.dataset.off;
    if (hint) hint.textContent = on ? tog.dataset.hintOn : tog.dataset.hintOff;
    if (vid) { if (on) { vid.play().catch(function () {}); } else { vid.pause(); } }
  });

  /* Carrousel: pijlen */
  function carState(root) {
    var t = root.querySelector('[data-lm-car-track]'); if (!t) return;
    var max = t.scrollWidth - t.clientWidth - 2;
    var nav = root.querySelector('.lm-car-nav');
    if (nav) nav.classList.toggle('off', max <= 0);
    root.querySelectorAll('[data-lm-car]').forEach(function (b) {
      b.disabled = b.dataset.lmCar === '-1' ? t.scrollLeft <= 2 : t.scrollLeft >= max;
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lm-car]'); if (!b) return;
    var root = b.closest('[data-lm-car-root]'); if (!root) return;
    var t = root.querySelector('[data-lm-car-track]'); if (!t) return;
    var item = t.firstElementChild, stepW = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(t).columnGap || 0) : t.clientWidth;
    var n = Math.max(1, Math.floor(t.clientWidth / stepW));
    t.scrollBy({ left: parseInt(b.dataset.lmCar, 10) * stepW * n, behavior: 'smooth' });
  });
  function initCars() {
    document.querySelectorAll('[data-lm-car-root]').forEach(function (root) {
      var t = root.querySelector('[data-lm-car-track]'); if (!t || t.dataset.lmCarReady) return; t.dataset.lmCarReady = '1';
      var raf; t.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { carState(root); }); }, { passive: true });
      carState(root);
    });
  }
  window.addEventListener('resize', function () { document.querySelectorAll('[data-lm-car-root]').forEach(carState); });

  /* Collectie: sorteren */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-lm-sort]'); if (!sel) return;
    var u = new URL(location.href); u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page'); location.href = u.toString();
  });

  /* Productpagina */
  function initProduct(root) {
    if (root.dataset.lmReady) return; root.dataset.lmReady = '1';
    var variants = []; try { variants = JSON.parse(root.querySelector('[data-lm-variants]').textContent); } catch (e) {}
    var form = root.querySelector('form[data-lm-form]');
    var idInput = root.querySelector('[data-lm-variant-id]');
    var priceEl = root.querySelector('[data-lm-price]'), cmpEl = root.querySelector('[data-lm-compare]'), saveEl = root.querySelector('[data-lm-save]');
    var btn = root.querySelector('[data-lm-add]'), btn2 = root.querySelector('[data-lm-add-sticky]') || document.querySelector('[data-lm-add-sticky]'), btnLabel = root.querySelector('[data-lm-add-label]');
    var bar = btn2 ? btn2.closest('.lm-stickybar') : null, stickyLabel = bar ? bar.querySelector('[data-lm-sticky-label]') : null;
    var stickyPrice = root.querySelector('[data-lm-sticky-price]') || document.querySelector('[data-lm-sticky-price]');
    var varName = root.querySelector('[data-lm-var-name]');
    var err = root.querySelector('[data-lm-error]');

    function current() {
      var groups = root.querySelectorAll('.lm-chips');
      if (!groups.length) return variants.find(function (v) { return v.available; }) || variants[0] || null;
      var opts = [].map.call(groups, function (g) { var c = g.querySelector('input:checked'); return c ? c.value : null; });
      return variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); }) || null;
    }
    /* Chips: waarde doorstrepen als de combinatie met de andere gekozen opties uitverkocht is (blijft klikbaar) */
    function markChips() {
      var groups = [].slice.call(root.querySelectorAll('.lm-chips')); if (!groups.length) return;
      var opts = groups.map(function (g) { var c = g.querySelector('input:checked'); return c ? c.value : null; });
      groups.forEach(function (g, gi) {
        g.querySelectorAll('input').forEach(function (inp) {
          var want = opts.slice(); want[gi] = inp.value;
          var hit = variants.find(function (v) { return v.options.every(function (o, i) { return o === want[i]; }); });
          var lab = inp.closest('.lm-chip'); if (!lab) return;
          var off = !hit || !hit.available;
          lab.classList.toggle('lm-chip-off', off);
          if (off) { lab.setAttribute('title', hit ? 'Uitverkocht' : 'Niet beschikbaar'); } else { lab.removeAttribute('title'); }
        });
      });
    }
    function render() {
      markChips();
      var v = current();
      if (!v) { if (btn) { btn.disabled = true; } if (btn2) { btn2.disabled = true; } if (btnLabel) btnLabel.textContent = root.dataset.unavailable; return; }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      root.querySelectorAll('[data-lm-price-copy]').forEach(function (x) { x.textContent = money(v.price); });
      root.querySelectorAll('[data-lm-compare-copy]').forEach(function (x) { x.textContent = (v.compare_at_price && v.compare_at_price > v.price) ? money(v.compare_at_price) : ''; });
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      if (cmpEl) { if (sale) { cmpEl.textContent = money(v.compare_at_price); cmpEl.hidden = false; } else { cmpEl.textContent = ''; cmpEl.hidden = true; } }
      if (saveEl) { if (sale) { saveEl.textContent = root.dataset.saveLabel + ' ' + money(v.compare_at_price - v.price); saveEl.hidden = false; } else { saveEl.textContent = ''; saveEl.hidden = true; } }
      if (varName) varName.textContent = v.title === 'Default Title' ? '' : v.title;
      var ok = v.available;
      if (btn) btn.disabled = !ok; if (btn2) btn2.disabled = !ok;
      if (btnLabel) btnLabel.textContent = ok ? root.dataset.addLabel + ' · ' + money(v.price) : root.dataset.soldout;
      if (stickyLabel) stickyLabel.textContent = ok ? root.dataset.addLabel : root.dataset.soldout;
    }
    root.addEventListener('change', function (e) { if (e.target.closest('.lm-chips input')) render(); });

    /* Deal-set: uitvoering kiezen, totaal bijwerken */
    function setTotals() {
      var box = root.querySelector('[data-lm-deal]'); if (!box) return;
      var now = 0, was = 0, v = current();
      var main = box.querySelector('[data-lm-set-main]');
      if (main && v) { now += v.price; was += Math.max(v.compare_at_price || 0, v.price); }
      box.querySelectorAll('[data-lm-set-row]').forEach(function (row) {
        var sel = row.querySelector('select[data-lm-set-item]'), o = sel ? sel.options[sel.selectedIndex] : null;
        var n = parseInt(o ? o.dataset.now : row.dataset.now, 10) || 0, w = parseInt(o ? o.dataset.was : row.dataset.was, 10) || n;
        now += n; was += w;
        var nb = row.querySelector('[data-now]'), wb = row.querySelector('[data-was]');
        if (nb) nb.textContent = money(n); if (wb) wb.textContent = money(w);
      });
      var q = function (s) { return box.querySelector(s); };
      if (q('[data-lm-set-now]')) q('[data-lm-set-now]').textContent = money(now);
      if (q('[data-lm-set-was]')) q('[data-lm-set-was]').textContent = money(was);
      if (q('[data-lm-set-save]')) q('[data-lm-set-save]').textContent = money(was - now);
      var f = q('[data-lm-set-free]'); if (f) f.hidden = now < parseInt(f.dataset.free, 10);
      var mainNow = main ? main.querySelector('em') : null;
      if (mainNow && v) mainNow.innerHTML = (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '') + money(v.price);
    }
    root.addEventListener('change', function (e) { if (e.target.closest('.lm-deal-sel') || e.target.closest('.lm-chips input')) setTotals(); });

    /* Sticky koopbalk: alleen tonen als de echte knop uit beeld is en de footer nog niet in beeld */
    if (bar && btn && 'IntersectionObserver' in window) {
      var btnOut = false, footIn = false;
      var upd = function () { bar.classList.toggle('show', btnOut && !footIn); };
      new IntersectionObserver(function (en) { var r = en[0]; btnOut = !r.isIntersecting && r.boundingClientRect.top < 0; upd(); }).observe(btn);
      var foot = document.querySelector('.footer, footer');
      if (foot) new IntersectionObserver(function (en) { footIn = en[0].isIntersecting; upd(); }).observe(foot);
    } else if (bar) { bar.classList.add('show'); }
    render();

    /* Galerij: thumbs (gedelegeerd op root) en swipe op mobiel */
    var main = root.querySelector('[data-lm-gal-main]');
    function thumbs() { return [].slice.call(root.querySelectorAll('[data-lm-thumb]')); }
    function show(id) {
      thumbs().forEach(function (x) { x.classList.toggle('on', x.dataset.lmThumb === id); });
      if (!main) return;
      main.querySelectorAll('[data-lm-media]').forEach(function (m) {
        var vis = m.dataset.lmMedia === id;
        if (vis) { var im = m.tagName === 'IMG' ? m : m.querySelector('img'); if (im && im.loading === 'lazy') im.loading = 'eager'; }
        m.hidden = !vis;
        var v = m.tagName === 'VIDEO' ? m : m.querySelector('video');
        if (v) { if (vis) { v.play().catch(function () {}); } else { v.pause(); } }
      });
      warm(id);
    }
    /* Buren alvast laden, zodat het grote beeld niet zwart blijft na een klik */
    function warm(id) {
      if (!main) return;
      var list = [].slice.call(main.querySelectorAll('[data-lm-media]'));
      var i = list.findIndex(function (m) { return m.dataset.lmMedia === id; }); if (i < 0) return;
      [i - 1, i + 1].forEach(function (k) {
        var m = list[(k + list.length) % list.length]; var im = m && (m.tagName === 'IMG' ? m : m.querySelector('img'));
        if (im && !im.complete) { var pre = new Image(); pre.sizes = im.sizes; pre.srcset = im.srcset; pre.src = im.src; }
      });
    }
    root.addEventListener('mouseover', function (e) {
      var b = e.target.closest('[data-lm-thumb]'); if (!b || !main) return;
      var m = main.querySelector('[data-lm-media="' + b.dataset.lmThumb + '"]'); var im = m && (m.tagName === 'IMG' ? m : m.querySelector('img'));
      if (im && im.loading === 'lazy') im.loading = 'eager';
    });
    function step(dir) {
      var list = thumbs(); if (list.length < 2) return;
      var i = list.findIndex(function (x) { return x.classList.contains('on'); });
      var next = list[(i + dir + list.length) % list.length];
      show(next.dataset.lmThumb);
      if (next.scrollIntoView) { try { next.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) {} }
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-lm-thumb]'); if (!b || !root.contains(b)) return;
      e.preventDefault(); show(b.dataset.lmThumb);
    });
    if (main) {
      var sx = 0, sy = 0, swiping = false;
      main.addEventListener('touchstart', function (e) {
        if (e.target.closest('iframe,video')) { swiping = false; return; }
        var t = e.touches[0]; sx = t.clientX; sy = t.clientY; swiping = true;
      }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (!swiping) return; swiping = false;
        var t = e.changedTouches[0]; var dx = t.clientX - sx, dy = t.clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) step(dx < 0 ? 1 : -1);
      }, { passive: true });
      main.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      });
    }

    /* Kaching: als de app een deal toont, neemt die de prijs over */
    var kBox = root.querySelector('[data-lm-kaching]');
    function kachingOn() {
      if (!kBox) return false;
      var w = kBox.querySelector('.kaching-bundles, .kaching-bundles__block');
      return !!(w && w.offsetHeight > 20);
    }
    function kachingSync() {
      var on = kachingOn();
      root.classList.toggle('lm-k-on', on);
      if (bar) bar.classList.toggle('lm-k-on', on);
      if (btnLabel && on) { var v = current(); btnLabel.textContent = v && v.available ? root.dataset.addLabel : root.dataset.soldout; }
    }
    if (kBox) {
      var kTries = 0, kT = setInterval(function () { kachingSync(); if (kachingOn() || ++kTries > 40) clearInterval(kT); }, 250);
      if ('MutationObserver' in window) new MutationObserver(kachingSync).observe(kBox, { childList: true, subtree: true });
      root.addEventListener('change', function () { setTimeout(kachingSync, 0); });
    }

    /* Toevoegen, met erbij-producten; cart-drawer van Dawn als die er is */
    function add(e) {
      if (e) e.preventDefault(); if (!form) return;
      var v = current(); if (!v || !v.available) return;
      var items = [{ id: v.id, quantity: 1 }], extra = [];
      root.querySelectorAll('[data-lm-addon]:checked').forEach(function (a) { if (a.disabled || a.closest('[data-lm-addon-soldout]')) return; var id = parseInt(a.value, 10); if (id) extra.push({ id: id, quantity: 1 }); });
      items = items.concat(extra);
      var setPick = root.querySelector('[data-lm-deal-pick="set"]:checked');
      if (setPick) root.querySelectorAll('[data-lm-set-item]').forEach(function (el) { var id = parseInt(el.value, 10); if (id) items.push({ id: id, quantity: 1 }); });
      if (btn) btn.disabled = true; if (btn2) btn2.disabled = true; if (err) err.hidden = true;
      var drawer = document.querySelector('cart-drawer');
      var unlocked = false, answered = false;
      function unlock() { if (unlocked) return; unlocked = true; if (btn) btn.disabled = false; if (btn2) btn2.disabled = false; }
      var req, kachingReq = kachingOn();
      if (kachingReq) {
        /* Kaching leest zijn eigen velden uit het formulier en vult de set aan */
        var fd = new FormData(form);
        if (drawer) { fd.append('sections', 'cart-drawer,cart-icon-bubble'); fd.append('sections_url', location.pathname); }
        req = { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd };
      } else {
        var body = { items: items };
        if (drawer) body.sections = 'cart-drawer,cart-icon-bubble';
        req = { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) };
      }
      fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', req)
        .then(function (r) { answered = true; return r.json(); })
        .then(function (res) {
          if (res.status) { unlock(); fail(res.description || res.message); return; }
          /* Kaching: erbij-producten staan buiten het formulier, dus apart toevoegen */
          if (kachingReq && extra.length) {
            var body2 = { items: extra };
            if (drawer) body2.sections = 'cart-drawer,cart-icon-bubble';
            return fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body2) })
              .then(function (r) { return r.json(); })
              .then(function (res2) { unlock(); if (res2.status) { finish(res); toast(EXTRA_FAIL, 5000); } else { finish(res2); } },
                    function () { unlock(); finish(res); toast(EXTRA_FAIL, 5000); });
          }
          unlock(); finish(res);
        })
        .catch(function () {
          unlock();
          /* Server heeft geantwoord: het product kan al in de winkelwagen zitten, dus niet opnieuw toevoegen */
          if (answered) { location.href = (window.routes && window.routes.cart_url) || '/cart'; return; }
          if (kachingReq) { if (err) { err.textContent = 'Toevoegen lukte niet. Probeer het opnieuw.'; err.hidden = false; } } else { form.submit(); }
        });
      var EXTRA_FAIL = 'Het erbij-product kon niet mee. Voeg het los toe.';
      function fail(msg) { if (err) { err.textContent = msg; err.hidden = false; } else { toast(msg); } }
      function finish(res) {
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
            document.dispatchEvent(new CustomEvent('lm:added', { detail: res }));
          } else {
            toast(root.dataset.addedLabel);
            setTimeout(function () { location.href = (window.routes && window.routes.cart_url) || '/cart'; }, 600);
          }
      }
    }
    if (form) form.addEventListener('submit', add);
    if (btn2) btn2.addEventListener('click', add);
  }

  function init() { document.querySelectorAll('[data-lm-product]').forEach(initProduct); initCars(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  window.lmInit = init;
})();
